// extracted by mini-css-extract-plugin
module.exports = {"calendargroups":"CalendarGroups_calendargroups__ZS3TF","calendargroups-loadpast":"CalendarGroups_calendargroups-loadpast__kbEj6"};